<ng-container *transloco="let convert;">
  <div class="dealer-group-popover">
    @if (dealerGroups$ | async; as dealerGroups) {
      @if (isSellerAssociatedToMultipleLeadSellerGroup) {
        <div class="form-group">
          <label class="text-uppercase d-block"
            >{{convert('common.labelSearch')}}
            <input type="text" class="form-control" (input)="search($event)"/>
          </label>
        </div>
      }
      @if (isSellerAssociatedToMultipleLeadSellerGroup) {
        <div class="custom-control custom-checkbox mb-2">
          <input
            class="custom-control-input"
            id="dealer-group-popover-select-all"
            type="checkbox"
            [appTrack]="{elem: 'checkbox', trigger: 'filter', name: 'All Groups'}"
            [checked]="allSelected$ | async"
            (change)="toggleAll()"
            />
          <label class="custom-control-label ms-2" for="dealer-group-popover-select-all">{{convert('sellModule.manageInventory.preferencesPopover.labelAllGroups')}}</label>
        </div>
      }
      @for (groupUuid of dealerGroups.groupUuids; track groupUuid) {
        <app-dealer-group-section
          [groupUuid]="groupUuid"
          [state$]="preferencesState$"
          (selectGroup)="toggleGroup($event)"
          (selectMember)="toggleMember($event)"
          [dealershipGroupCount]="dealershipGroupCount"
          [leadSellerPreferencePopOver]=true
        ></app-dealer-group-section>
      }
    }
  </div>
</ng-container>
